import type { ReactNode } from 'react'
import { View } from 'react-native'
import { ScreenContainer } from '../../shared/ScreenContainer'
import { CashierHeader } from './CashierHeader'

interface CashierPublicLayoutProps {
  children: ReactNode
}

export function CashierPublicLayout({ children }: CashierPublicLayoutProps) {
  return (
    <ScreenContainer>
      <CashierHeader />
      <View className="flex-1">{children}</View>
    </ScreenContainer>
  )
}
